export const destroy = (self) => {
  if (self._mouseDownOnCanvasElHandler != null) {
    self._canvas_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnCanvasElHandler
    );
    self._mouseDownOnCanvasElHandler = null;
  }
  if (self._mouseDownOnSelectorPathElHandler != null) {
    self._selector_path_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnSelectorPathElHandler
    );
    self._mouseDownOnSelectorPathElHandler = null;
  }
  if (self._mouseDownOnSelectorScaleNCircleElHandler != null) {
    self._selector_n_circle_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnSelectorScaleNCircleElHandler
    );
    self._mouseDownOnSelectorScaleNCircleElHandler = null;
  }
  if (self._mouseDownOnSelectorScaleNECircleElHandler != null) {
    self._selector_ne_circle_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnSelectorScaleNECircleElHandler
    );
    self._mouseDownOnSelectorScaleNECircleElHandler = null;
  }
  if (self._mouseDownOnSelectorScaleECircleElHandler != null) {
    self._selector_e_circle_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnSelectorScaleECircleElHandler
    );
    self._mouseDownOnSelectorScaleECircleElHandler = null;
  }
  if (self._mouseDownOnSelectorScaleSECircleElHandler != null) {
    self._selector_se_circle_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnSelectorScaleSECircleElHandler
    );
    self._mouseDownOnSelectorScaleSECircleElHandler = null;
  }
  if (self._mouseDownOnSelectorScaleSCircleElHandler != null) {
    self._selector_s_circle_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnSelectorScaleSCircleElHandler
    );
    self._mouseDownOnSelectorScaleSCircleElHandler = null;
  }
  if (self._mouseDownOnSelectorScaleSWCircleElHandler != null) {
    self._selector_sw_circle_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnSelectorScaleSWCircleElHandler
    );
    self._mouseDownOnSelectorScaleSWCircleElHandler = null;
  }
  if (self._mouseDownOnSelectorScaleWCircleElHandler != null) {
    self._selector_w_circle_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnSelectorScaleWCircleElHandler
    );
    self._mouseDownOnSelectorScaleWCircleElHandler = null;
  }
  if (self._mouseDownOnSelectorScaleNWCircleElHandler != null) {
    self._selector_nw_circle_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnSelectorScaleNWCircleElHandler
    );
    self._mouseDownOnSelectorScaleNWCircleElHandler = null;
  }
  if (self._mouseDownOnSelectorRotateCircleElHandler != null) {
    self._selector_r_circle_el?.removeEventListener(
      "mousedown",
      self._mouseDownOnSelectorRotateCircleElHandler
    );
    self._mouseDownOnSelectorRotateCircleElHandler = null;
  }
  if (self._mouseMoveHandler != null) {
    self._window.removeEventListener("mousemove", self._mouseMoveHandler);
    self._mouseMoveHandler = null;
  }
  if (self._mouseUpHandler != null) {
    self._window.removeEventListener("mouseup", self._mouseUpHandler);
    self._mouseUpHandler = null;
  }
  if (self._canvas_el != null) {
    self._container_el?.removeChild(self._canvas_el);
  }
  self._container_el = null;
  self._canvas_el = null;
  self._dummy_g_el = null;
  self._layers_el = null;
  self._art_board_layer_el = null;
  self._background_layer_el = null;
  self._working_layer_el = null;
  self._foreground_layer_el = null;
  self._rubber_band_layer_el = null;
  self._path_editor_layer_el = null;
  self._art_board_rect_el = null;
  self._art_board_filter_drop_shadow_el = null;
  self._background_base_el = null;
  self._background_color_el = null;
  self._background_image_el = null;
  self._selector_path_el = null;
  self._selector_nw_circle_el = null;
  self._selector_n_circle_el = null;
  self._selector_ne_circle_el = null;
  self._selector_e_circle_el = null;
  self._selector_se_circle_el = null;
  self._selector_s_circle_el = null;
  self._selector_sw_circle_el = null;
  self._selector_w_circle_el = null;
  self._selector_r_circle_el = null;
  self._rubber_band_el = null;
  self._path_editor_line_container_el = null;
  self._path_editor_point_container_el = null;
  self._view_port = null;
  self._view_box = null;
  self._working_layer = null;
  self._art_board = null;
  self._background = null;
  self._selector_controller = null;
  self._rubber_band = null;
  self._grouping = null;
  self._locking = null;
  self._selection = null;
  self._selection_translate_transform = null;
  self._selection_scale_transform = null;
  self._selection_rotate_transform = null;
  self._translate_transform = null;
  self._scale_transform = null;
  self._stroke = null;
  self._stroke_sync = null;
  self._processing_task = null;
  self._path_editor_target_el = null;
  self._path_editor_list = [];
  self._path_editor_point_size_controller = null;
  self._mouseDownOnCanvasElHandler = null;
  self._mouseDownOnSelectorPathElHandler = null;
  self._mouseDownOnSelectorScaleNCircleElHandler = null;
  self._mouseDownOnSelectorScaleNECircleElHandler = null;
  self._mouseDownOnSelectorScaleECircleElHandler = null;
  self._mouseDownOnSelectorScaleSECircleElHandler = null;
  self._mouseDownOnSelectorScaleSCircleElHandler = null;
  self._mouseDownOnSelectorScaleSWCircleElHandler = null;
  self._mouseDownOnSelectorScaleWCircleElHandler = null;
  self._mouseDownOnSelectorScaleNWCircleElHandler = null;
  self._mouseDownOnSelectorRotateCircleElHandler = null;
  self._mouseMoveHandler = null;
  self._mouseUpHandler = null;
  self._is_mouse_down = false;
  self._is_mouse_move = false;
  self._mouse_down_position = {
    x: 0,
    y: 0,
  };
  self._mouse_move_position = {
    x: 0,
    y: 0,
  };
  self._rotate_transforming_origin_x = 0;
  self._rotate_transforming_origin_y = 0;
};
